'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefValue = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefValue = exports.DefValue = function DefValue(_ref) {
  var value = _ref.value,
      options = _ref.options;
  return _react2.default.createElement(
    'span',
    null,
    value.map(function (val) {
      return options.find(function (opt) {
        return opt.value === val;
      }).label;
    }).join(', ')
  );
};